"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoldoutLevelToJSON = exports.HoldoutLevelFromJSONTyped = exports.HoldoutLevelFromJSON = exports.HoldoutLevel = void 0;
/**
 *
 * @export
 */
exports.HoldoutLevel = {
    CampaignLevel: 'CAMPAIGN_LEVEL',
    AdAccountLevel: 'AD_ACCOUNT_LEVEL',
    Unknown: 'UNKNOWN'
};
function HoldoutLevelFromJSON(json) {
    return HoldoutLevelFromJSONTyped(json, false);
}
exports.HoldoutLevelFromJSON = HoldoutLevelFromJSON;
function HoldoutLevelFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.HoldoutLevelFromJSONTyped = HoldoutLevelFromJSONTyped;
function HoldoutLevelToJSON(value) {
    return value;
}
exports.HoldoutLevelToJSON = HoldoutLevelToJSON;
